import { memo } from "react";

function NextStopComplianceStopAPTMarker({ stopSequence, textColor, color }) {
  const shiftLeft = stopSequence && stopSequence < 10 ? 0 : -3;
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      {/* Generator: Sketch 52.5 (67469) - http://www.bohemiancoding.com/sketch */}
      <desc>Created with Sketch.</desc>
      <g
        id="Map-interactions"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="Stops-on-map-" transform="translate(1.000000, 1.000000)">
          <path
            d="M13.7125339,7.50054975 C13.958556,11.1357611 16.8642389,14.041444 20.4994503,14.2874661 C20.8244859,15.2999889 21,16.3794977 21,17.5 C21,23.2989899 16.2989899,28 10.5,28 C4.70101013,28 0,23.2989899 0,17.5 C0,11.7010101 4.70101013,7 10.5,7 C11.6205023,7 12.7000111,7.1755141 13.7125339,7.50054975 Z"
            id="Combined-Shape"
            stroke={textColor}
            fill={color}
          />
          <circle
            id="Oval-15"
            stroke={textColor}
            fill={color}
            cx={22}
            cy={6}
            r={6}
          />
          <path
            d="M7.24659163,15.6514202 C7.17393461,16.0964079 7.41752074,16.9417326 7.76228748,17.7270299 C8.07988686,18.4504464 8.54794386,19.1391204 9.17684924,19.7681687 L9.21716163,19.808893 C10.5320935,21.1232916 11.7628671,21.7610184 13.3886615,21.7668362 C13.4859099,21.6862186 14.0244232,21.2589875 14.2396996,20.7029757 C14.2351281,20.6996513 14.21892,20.6489536 14.2014652,20.6082293 C14.1251781,20.6082293 13.3886615,20.332297 13.1559586,20.3119349 C13.1559586,20.3119349 12.9229227,20.7938373 12.5849587,21.052992 C12.2469947,21.3121467 11.3192022,20.8938025 10.8234014,20.5310235 C10.404485,20.2268377 9.90971009,19.8745167 9.5074174,19.4789089 C9.10844945,19.0729123 8.83480346,18.6690578 8.52601889,18.2460234 C8.322379,17.9671864 7.89911645,17.3138004 7.98692709,16.7543089 C8.07473774,16.1948174 8.91583082,15.8886352 8.91416846,15.8632864 C8.73130815,15.1834394 8.73963298,15.3464644 8.52601889,14.7488972 C8.49027801,14.736015 8.44497853,14.7252106 8.41297797,14.7252106 C8.01794319,14.9321438 7.31924864,15.2064326 7.24659163,15.6514202 Z M13.8896931,23 C11.9726037,23 9.9909368,22.11709 8.45184077,20.5785622 L8.42127411,20.5458459 C6.82534992,18.9367198 5.95527634,16.9156263 6.0017721,14.9664227 L6.00521623,14.8226431 L6.09433312,14.7098579 C6.23209836,14.5346535 6.36814154,14.3801119 6.51107297,14.2376238 C7.03328933,13.7154542 7.64720568,13.3159707 8.33603187,13.0490745 C8.41955205,13.0167886 8.51426565,13 8.61672854,13 C8.84877687,13 9.37056271,13.1179509 9.50402279,13.4834266 C9.73908472,14.136031 10.0357105,14.9875161 10.2513992,15.8019802 C10.311241,16.0305639 10.2526908,16.582867 9.93324761,16.7843306 L9.17209466,17.2668963 C9.17898292,17.2729229 9.17553879,17.3917348 9.27455756,17.5273353 C9.56989179,17.9319845 9.91215231,18.3323289 10.2910067,18.718037 C10.6728747,19.0929832 11.0719634,19.4330607 11.4732047,19.7249247 C11.5515586,19.7821782 11.6398145,19.815325 11.7112802,19.815325 L11.9747562,19.4476969 L12.217137,19.0658631 C12.42809,18.7387 12.9563336,18.7292294 13.0157448,18.7292294 C13.0773087,18.7292294 13.1319842,18.7348257 13.1827852,18.7460181 C14.1854578,18.9698666 14.7821535,19.1622901 15.5476116,19.5092553 C15.8877195,19.6625054 16.1025472,20.2793801 15.9501444,20.6663797 C15.6849463,21.3529918 15.2854271,21.9668532 14.7645023,22.4890228 C14.6168352,22.6358158 14.4575442,22.7761515 14.2896428,22.9070168 L14.177278,22.9952647 L13.8896931,23 Z"
            id="Fill-1"
            fill={textColor}
          />
          <text
            id={2}
            fontFamily="OpenSans-SemiBold, Open Sans"
            fontSize={8}
            fontWeight={500}
            fill={textColor}
          >
            <tspan x={20 + shiftLeft} y={9}>
              {stopSequence}
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}

export default memo(NextStopComplianceStopAPTMarker);
